import React, { Component, useEffect } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { useSelector } from "react-redux";
import "./scss/style.scss";
const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);
let bamawlDomain = process.env.REACT_APP_BAMAWL_DOMAIN;
// Containers
const TheLayout = React.lazy(() => import("./containers/RecruitMainLayout"));

// Pages
const Login = React.lazy(() => import("./views/pages/login/Login"));
const Register = React.lazy(() => import("./views/pages/register/Register"));
const Page404 = React.lazy(() => import("./views/error-page/Page404"));
const Page403 = React.lazy(() => import("./views/error-page/Page403"));
const InvalidURL = React.lazy(() => import("./views/error-page/InvalidURL"));
const Page500 = React.lazy(() => import("./views/pages/page500/Page500"));
const UserForm = React.lazy(() => import("./views/userform/UserFormIndex"));
const SignIn = React.lazy(() => import("./views/login/SingIn"));
const Auth = React.lazy(() => import("./views/login/Auth"));
const RecruitAuth = React.lazy(() => import("./views/login/AuthForm"));
const Logout = React.lazy(() => import("./views/logout/Logout"));
const UserLogin = React.lazy(() =>
  import("./views/applicant-login/UserLoginIndex")
);
const NoPermission = React.lazy(() =>
  import("./views/error-page/NoPermission")
);

const EmailValidation = React.lazy(() =>
  import("./views/applicant-login/EmailValidationIndex")
);

const App = () => {
  let customer_name = window.location.href.split("/")[3];
  let project_name = window.location.href.split("/")[4];
  const loginEvt = useSelector((state) => state.login);

  if (customer_name === "" || customer_name === null) {
    customer_name = "demo";
  }

  // let lastUrl = "";

  // if (window.location.href) {
  //   lastUrl = window.location.href.split("/").pop();
  // }

  useEffect(() => {
    window.addEventListener("storage", (event) => {
      if (
        localStorage.getItem(`${customer_name}_SIGN_OUT`) &&
        window.location.href.split("/").pop() !== "sign-in"
      ) {
        window.location.href = `/${customer_name}/sign-in`;
        localStorage.removeItem(`${customer_name}_SIGN_OUT`);
      }
    });
  }, []);

  useEffect(() => {
    if (loginEvt && window.location.href.split("/").pop() === "sign-in") {
      window.location.href = `/${customer_name}/recruit/Dashboard`;
    }
  }, [loginEvt]);

  useEffect(() => {
    document.addEventListener("click", (e) => {
      let name = e.target.innerText;
      if (name == "ERP") {
        e.preventDefault();
        e.stopPropagation();
        window.open(`${bamawlDomain}/${customer_name}/erp/auth`, "_blank");
      } else if (
        name == "Manage Your Storage" ||
        name == "သိမ်းဆည်းမှုပမာဏကိုစီမံရန်"
      ) {
        e.preventDefault();
        e.stopPropagation();
        window.open(
          `${bamawlDomain}/${customer_name}/manage-your-storage/auth`,
          "_blank"
        );
      } else {
        let Route = e.target.getAttribute("route");
        if (Route != null) {
          let route = e.target.getAttribute("route").split("/", 2)[1];
          if (route != "dashboard-no-permission") {
            if (
              name == "Plan Management" ||
              name == "အလုပ်အစီအစဉ်များစီမံခန့်ခွဲမှု"
            ) {
              e.preventDefault();
              e.stopPropagation();
              window.open(
                `${bamawlDomain}/${customer_name}/plan/auth`,
                "_blank"
              );
            }
            if (name == "Expense" || name == "အသုံးစရိတ်စီမံခန့်ခွဲမှု") {
              e.preventDefault();
              e.stopPropagation();
              window.open(
                `${bamawlDomain}/${customer_name}/expense/auth`,
                "_blank"
              );
            }
            if (name == "Loan Management" || name == "ချေးငွေစီမံခန့်ခွဲမှု") {
              e.preventDefault();
              e.stopPropagation();
              window.open(
                `${bamawlDomain}/${customer_name}/loan/auth`,
                "_blank"
              );
            }
            if (name == "HR Management" || name == "HR စီမံခန့်ခွဲမှု") {
              e.preventDefault();
              e.stopPropagation();
              window.open(`${bamawlDomain}/${customer_name}/hr/auth`, "_blank");
            }
          }
        }
      }
    });
  }, []);
  return (
    <BrowserRouter>
      <React.Suspense fallback={loading}>
        <Switch>
          <Route
            exact
            path={`/${customer_name}/logout`}
            name="Logout"
            render={(props) => <Logout {...props} />}
          />
          <Route
            exact
            path={`/${customer_name}/erp/auth`}
            name="ERP Dashboard"
            render={(props) =>
              window.location.assign(
                `${bamawlDomain}/${customer_name}/erp/auth`
              )
            }
          />
          <Route
            exact
            path={`/${customer_name}/hr/auth`}
            name="HR Dashboard"
            render={(props) =>
              window.location.assign(`${bamawlDomain}/${customer_name}/hr/auth`)
            }
          />
          <Route
            exact
            path={`/${customer_name}/loan/auth`}
            name="Loan Dashboard"
            render={(props) =>
              window.location.assign(
                `${bamawlDomain}/${customer_name}/loan/auth`
              )
            }
          />
          <Route
            exact
            path={`/${customer_name}/expense/auth`}
            name="Expense Dashboard"
            render={(props) =>
              window.location.assign(
                `${bamawlDomain}/${customer_name}/expense/auth`
              )
            }
          />

          <Route
            exact
            path={`/${customer_name}/plan/auth`}
            name="Plan Calendar"
            render={(props) =>
              window.location.assign(
                `${bamawlDomain}/${customer_name}/plan/auth`
              )
            }
          />

          <Route
            exact
            path={`/${customer_name}/manage-your-storage/auth`}
            name="Plan Calendar"
            render={(props) =>
              window.location.assign(
                `${bamawlDomain}/${customer_name}/manage-your-storage/auth`
              )
            }
          />

          <Route
            exact
            path={`/${customer_name}/recruit/resume-management/job-applied-list-detail`}
            name="Applicant Detail Form"
            render={(props) => <TheLayout {...props} />}
          />
          <Route
            exact
            path={`/${customer_name}`}
            name="Sign In"
            render={(props) => <SignIn {...props} />}
          />
          <Route
            exact
            path={`/${customer_name}/sign-in`}
            name="Sign In"
            render={(props) => <SignIn {...props} />}
          />
          <Route
            exact
            path={`/${customer_name}`}
            name="Sign In"
            render={(props) => <SignIn {...props} />}
          />
          <Route
            exact
            path={`/${customer_name}/recruit/auth`}
            name="Auth"
            render={(props) => <RecruitAuth {...props} />}
          />
          <Route
            exact
            path={`/${customer_name}/auth`}
            name="Auth"
            render={(props) => <Auth {...props} />}
          />
          <Route
            exact
            path={`/${customer_name}/template/user-login/:id`}
            name="User Login Page"
            render={(props) => <UserLogin {...props} />}
          ></Route>
          <Route
            exact
            path={`/${customer_name}/template/email-verification`}
            name="Email Verification"
            render={(props) => <EmailValidation {...props} />}
          ></Route>
          <Route
            exact
            path={`/${customer_name}/template/user-form`}
            name="User-Form"
            render={(props) => <UserForm {...props} />}
          ></Route>
          <Route
            exact
            path={`/${customer_name}/recruit/no-permission`}
            name="No Permission"
            render={(props) => <NoPermission {...props} />}
          />
          <Route
            exact
            path={`/${customer_name}/${project_name}/403`}
            name="Page 403"
            render={(props) => <Page403 {...props} />}
          />
          <Route
            exact
            path={`/${customer_name}/${project_name}/404`}
            name="No Permission"
            render={(props) => <Page404 {...props} />}
          />
          <Route
            exact
            path={`/${customer_name}/${project_name}/500`}
            name="Page 500"
            render={(props) => <Page500 {...props} />}
          />
          <Route
            exact
            path={`/${customer_name}/recruit/dashboard`}
            name="Dashboard"
            render={(props) => <TheLayout {...props} />}
          />
          <Route
            path={`/${customer_name}/recruit/dashboard-no-permission`}
            name="Dashboard No Permission"
            render={(props) => <TheLayout {...props} />}
          />
          <Route
            path={`/${customer_name}/hr/dashboard-no-permission`}
            name="Dashboard No Permission"
            render={(props) => <TheLayout {...props} />}
          />
          <Route
            path={`/${customer_name}/expense/dashboard-no-permission`}
            name="Dashboard No Permission"
            render={(props) => <TheLayout {...props} />}
          />
          <Route
            path={`/${customer_name}/loan/dashboard-no-permission`}
            name="Dashboard No Permission"
            render={(props) => <TheLayout {...props} />}
          />
          <Route
            path={`/${customer_name}/plan/dashboard-no-permission`}
            name="Dashboard No Permission"
            render={(props) => <TheLayout {...props} />}
          />
          <Route
            path={`/${customer_name}/recruit/job-and-position-management/job-categories-registration`}
            name="Job Categories Registration"
            render={(props) => <TheLayout {...props} />}
          />
          <Route
            path={`/${customer_name}/recruit/job-and-position-management/position-registration`}
            name="Position Registration"
            render={(props) => <TheLayout {...props} />}
          />
          <Route
            path={`/${customer_name}/recruit/job-and-position-management/job-and-position-registration`}
            name="Job and Position Registration"
            render={(props) => <TheLayout {...props} />}
          />
          <Route
            path={`/${customer_name}/recruit/template-management/template-create`}
            name="Create New CV"
            render={(props) => <TheLayout {...props} />}
          />
          <Route
            path={`/${customer_name}/recruit/template-management/template-list`}
            name="Template List"
            render={(props) => <TheLayout {...props} />}
          />
          <Route
            path={`/${customer_name}/recruit/template-management/template-permission`}
            name="Template Permission"
            render={(props) => <TheLayout {...props} />}
          />
          <Route
            path={`/${customer_name}/recruit/template-management/template-permission-list`}
            name="Template Permission List"
            render={(props) => <TheLayout {...props} />}
          />
          <Route
            exact
            path={`/${customer_name}/recruit/resume-management/interview-page`}
            name="Interview Page"
            render={(props) => <TheLayout {...props} />}
          />
          <Route
            exact
            path={`/${customer_name}/recruit/resume-management/approval-page`}
            name="Approval Page"
            render={(props) => <TheLayout {...props} />}
          />
          <Route
            path={`/${customer_name}/recruit/resume-management/job-applied-list`}
            name="Job Applied List"
            render={(props) => <TheLayout {...props} />}
          />
          <Route
            path={`/${customer_name}/recruit/resume-management/skill-assessment-list`}
            name="Skill Assessment List"
            render={(props) => <TheLayout {...props} />}
          />
          <Route
            path={`/${customer_name}/recruit/resume-management/interview-list`}
            name="Interview List"
            render={(props) => <TheLayout {...props} />}
          />
          <Route
            path={`/${customer_name}/recruit/resume-management/offer-list`}
            name="Offer List"
            render={(props) => <TheLayout {...props} />}
          />
          <Route
            exact
            path={`/${customer_name}/recruit/resume-management/candidate-information-entry`}
            name="User-Form"
            render={(props) => <TheLayout {...props} />}
          ></Route>
          <Route
            exact
            path={`/${customer_name}/recruit/role-management/role-&-permission-registration`}
            name="Role & Permission Registration"
            render={(props) => <TheLayout {...props} />}
          />
          <Route
            exact
            path={`/${customer_name}/recruit/role-management/role-registration`}
            name="Role Registration"
            render={(props) => <TheLayout {...props} />}
          />
          <Route
            exact
            path={`/${customer_name}/recruit/role-management/role-&-permission-list`}
            name="Role & Permission List"
            render={(props) => <TheLayout {...props} />}
          />
          <Route
            exact
            path={`/${customer_name}/recruit/role-management/role-&-permission-list-detail`}
            name="Role and Permission Detail"
            render={(props) => <TheLayout {...props} />}
          />
          <Route
            exact
            path={`/${customer_name}/recruit/role-management/employee-role-registration`}
            name="Employee Role Registration"
            render={(props) => <TheLayout {...props} />}
          />
          <Route
            exact
            path={`/${customer_name}/recruit/resume-management/offer-letter-preparation`}
            name="Offer Letter Preparation"
            render={(props) => <TheLayout {...props} />}
          />
          <Route
            exact
            path={`/${customer_name}/recruit/signature/signature-list`}
            name="Signature List"
            render={(props) => <TheLayout {...props} />}
          />
          <Route
            path={`/${customer_name}/recruit/resume-management/skill-test-page`}
            name="SkillTest Page"
            render={(props) => <TheLayout {...props} />}
          />
          <Route
            exact
            path={`/${customer_name}/recruit/offer-letter-preparation`}
            name="Offer Letter Preparation"
            render={(props) => <TheLayout {...props} />}
          />
          <Route
            path={`/${customer_name}/recruit/not-register`}
            name="Not Register"
            render={(props) => <TheLayout {...props} />}
          />
          <Route
            path={`/${customer_name}/recruit/hr/not-register`}
            name="Not Register"
            render={(props) => <TheLayout {...props} />}
          />
          <Route
            path={`/${customer_name}/recruit/plan/not-register`}
            name="Not Register"
            render={(props) => <TheLayout {...props} />}
          />
          <Route
            path={`/${customer_name}/recruit/expense/not-register`}
            name="Not Register"
            render={(props) => <TheLayout {...props} />}
          />
          <Route
            path={`/${customer_name}/recruit/loan/not-register`}
            name="Not Register"
            render={(props) => <TheLayout {...props} />}
          />
          <Route
            path="/"
            name="Home"
            render={() => {
              window.location.href = `/${customer_name}/recruit/404`;
            }}
          />
        </Switch>
      </React.Suspense>
    </BrowserRouter>
  );
};

export default App;
